import { useEffect, useState } from "react";
import { nowPositionY } from "@/lib/agenda-time";

type Props = {
  startHour: string;
  endHour: string;
  color?: string;
};

/**
 * Pequena pill colorida com o horário atual exato (ex: "14:32") posicionada
 * ao lado da linha do "agora" na TimeColumn. Atualiza a cada 30s.
 */
export function CurrentTimeLabel({ startHour, endHour, color = "#F43F5E" }: Props) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const y = nowPositionY(startHour, endHour, now);
  if (y === null) return null;

  const h = String(now.getHours()).padStart(2, "0");
  const m = String(now.getMinutes()).padStart(2, "0");

  return (
    <div
      className="pointer-events-none absolute left-0 right-0 z-30 flex items-center justify-center"
      style={{ top: y - 9 }}
      aria-hidden
    >
      <span
        className="rounded px-1 py-0 text-[10px] font-bold tabular-nums text-white shadow-sm"
        style={{ background: color }}
      >
        {h}:{m}
      </span>
    </div>
  );
}
